'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.cookie = cookie;
exports.default = cookieMiddleware;

var _componentCookie = require('component-cookie');

var _componentCookie2 = _interopRequireDefault(_componentCookie);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/*
 * Action types
 */
var GET_COOKIE = 'EFFECT_GET_COOKIE'; /*
                                       * A part of these functions are:
                                       *   Copyright Weo.io <info@weo.io>
                                       *   Released under the MIT license.
                                       *   https://github.com/redux-effects/redux-effects-cookie/blob/master/src/index.js
                                       */

var SET_COOKIE = 'EFFECT_SET_COOKIE';

/*
 * Action creators
 */
function cookie(name, value) {
  var options = arguments.length <= 2 || arguments[2] === undefined ? {} : arguments[2];

  return arguments.length < 2 ? { type: GET_COOKIE, payload: { name: name } } : { type: SET_COOKIE, payload: { name: name, value: value, options: options } };
}

/*
 * Middleware
 */
function cookieMiddleware() {
  var cookieFactories = [browserCookie, function (cookies) {
    return cookies;
  }, // https://www.npmjs.com/package/cookies
  expressCookie];
  var cookieFactory = cookieFactories[Math.min(arguments.length, 2)];
  var cookie = cookieFactory.apply(undefined, arguments);

  return function () {
    return function (next) {
      return function (action) {
        var type = action.type;

        if (type !== GET_COOKIE && type !== SET_COOKIE) {
          return next(action);
        }

        var _action$payload = action.payload;
        var name = _action$payload.name;
        var value = _action$payload.value;
        var options = _action$payload.options;

        return type === GET_COOKIE ? Promise.resolve(cookie.get(name)) : Promise.resolve(cookie.set(name, value, options));
      };
    };
  };
}

function browserCookie() {
  return {
    get: function get(name) {
      return (0, _componentCookie2.default)(name);
    },
    set: function set(name, value, options) {
      return (0, _componentCookie2.default)(name, value, options);
    }
  };
}

function expressCookie(req, res) {
  return {
    get: function get(name) {
      return req.cookies[name];
    },
    set: function set(name, value, options) {
      return value != null ? res.cookie(name, value, options) : res.clearCookie(name, options);
    }
  };
}